/**
 * Number Control Component
 * Renders numeric input with min/max constraints
 */

import React from 'react';
import { Box } from '@mui/material';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { NumberSettings } from '../../../../types/ControlTypes';
import { BaseTextField } from '../BaseTextField';
import { LabelWithInfo } from './LabelWithInfo';

export const NumberControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  description,
  required,
  control,
}) => {
  const settings = control.settings as NumberSettings;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange(val === '' ? '' : Number(val));
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <LabelWithInfo
          label={label || name}
          description={description}
          required={required}
        />
      </Box>
      <BaseTextField
        type="number"
        value={value !== undefined && value !== null ? value : ''}
        onChange={handleChange}
        placeholder={settings?.placeholder}
        size="small"
        fullWidth
        disabled={disabled || readonly}
        error={!!error}
        helperText={error || (settings?.unit ? `Unit: ${settings.unit}` : '')}
        inputProps={{
          step: settings?.step || 1,
          min: settings?.minimum,
          max: settings?.maximum,
        }}
      />
    </Box>
  );
};

export default NumberControl;
